import { CHECKOUT_API_URL } from "../config/site";

export async function getCheckoutStatus({ orderId, sessionId, signal }) {
  const query = new URLSearchParams({
    order_id: orderId,
    session_id: sessionId,
  });
  const response = await fetch(
    `${CHECKOUT_API_URL}/checkout-status.php?${query.toString()}`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
      cache: "no-store",
      signal,
    }
  );
  const text = await response.text();
  let data;

  try {
    data = JSON.parse(text);
  } catch (error) {
    throw new Error("El servidor no ha devuelto una respuesta válida.");
  }

  if (!response.ok || !data.ok) {
    throw new Error("No se ha podido verificar el pago.");
  }

  return data;
}
